import { connect } from 'react-redux';
import CommercialInfosComponent from '../components/CommercialInfosComponent';
import { showSpotModal } from '../../spot/actions/spotActions';

const mapStateToProps = (state) => ({
    musicLive: state.aovivoBar.NowPlaying.musicLive,
});
const mapDispatchToProps = (dispatch) => ({
    showSpotModal: (spotSlug) => {
        dispatch(showSpotModal(spotSlug));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(CommercialInfosComponent);
